













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns } from '@/store/types';
import { JitsiActionsKeys } from '@/store/types/jitsi';
import Moveable from 'vue-moveable';
import { OnDrag, OnDragStart, OnResize } from 'moveable';

@Component({
  components: {
    Moveable,
  },
})
export default class Jitsi extends Vue {
  @Action(JitsiActionsKeys.JOIN_MEET) joinMeet!: () => void;
  @Action(JitsiActionsKeys.STOP_MEET) stopMeet!: () => void;
  @Action(JitsiActionsKeys.LEAVE_MEET) leaveMeet!: () => void;
  @Getter currentUser!: NonNullable<RootGettersReturns['currentUser']>;
  @Getter sessionPin!: RootGettersReturns['sessionPin'];
  @Getter isMeetOngoing!: RootGettersReturns['isMeetOngoing'];
  @Getter isMeetJoined!: RootGettersReturns['isMeetJoined'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  api: any = null;

  minimised = false;

  domain = 'meet.jit.si';
  options = {
    roomName: `smartboard`,
    parentNode: null as Element | null,
    userInfo: {
      displayName: '',
    },
    interfaceConfigOverwrite: {
      TOOLBAR_BUTTONS: [
        'microphone',
        'camera',
        'closedcaptions',
        'fullscreen',
        'fodeviceselection',
        'hangup',
        'etherpad',
        'settings',
        'videoquality',
        'filmstrip',
        'stats',
        'shortcuts',
        'tileview',
        'help',
        'mute-everyone',
      ],
      SETTINGS_SECTIONS: ['devices'],
      SHOW_CHROME_EXTENSION_BANNER: false,
      VERTICAL_FILMSTRIP: false,
      HIDE_INVITE_MORE_HEADER: true,
      SHOW_PROMOTIONAL_CLOSE_PAGE: false,
      CLOSE_PAGE_GUEST_HINT: false,
      DISPLAY_WELCOME_PAGE_CONTENT: false,
      SHOW_WATERMARK_FOR_GUESTS: false,
      SHOW_JITSI_WATERMARK: false,
      TOOLBAR_ALWAYS_VISIBLE: true,
    },
    configOverwrite: {
      disableInviteFunctions: true,
      enableClosePage: false,
    },
  };

  width = 400;
  height = 280;
  x = -400;
  y = 150;

  private rect = {
    x: this.x,
    y: this.y,
    width: this.width,
    height: this.height,
  };

  get styleParams() {
    return {
      width: this.width ? `${this.width}px` : 'auto',
      height: this.height ? `${this.height}px` : 'auto',
      transform: `translate3d(${this.x}px, ${this.y}px, 0)`,
    };
  }

  prevHeight = 0;

  async toggleMinimised() {
    this.minimised = !this.minimised;
    if (this.minimised) {
      const minusTop = this.rect.height / 2 - 36 / 2;
      this.rect.y = this.rect.y - minusTop;
    } else {
      const minusTop = this.rect.height / 2 - 36 / 2;
      this.rect.y = this.rect.y + minusTop;
    }

    this.applyMinMax();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    await this.$nextTick();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this.$refs.moveable as any).updateRect();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this.$refs.moveable as any).updateTarget();
  }

  constMoveable = {
    draggable: true,
    throttleDrag: 0,
    resizable: true,
    throttleResize: 1,
    keepRatio: false,
    pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
    origin: false,
  };

  get moveable() {
    return this.isMeetOngoing
      ? this.minimised
        ? {
            draggable: true,
          }
        : {
            ...this.constMoveable,
          }
      : {};
  }

  @Watch('isMeetJoined')
  meetJoined(newVal: boolean) {
    if (newVal) {
      this.createMeet();
    } else {
      this.disposeJitsi();
    }
  }

  @Watch('isMeetOngoing')
  meetOngoing(newVal: boolean) {
    if (!newVal) {
      this.disposeJitsi();
    }
  }

  mounted() {
    this.minimised = false;
    this.meetJoined(this.isMeetJoined);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const controls = (this.$refs.moveable as any).moveable.innerMoveable.moveable.moveable.controlBox
      .element as HTMLElement;

    Array.from(controls.childNodes).forEach(el => ((el as HTMLElement).style.background = 'none'));
    controls.style.opacity = '0';
    window.addEventListener('resize', this.applyMinMax);
    this.y = this.isGuest ? 120 : 150;
    this.rect.y = this.y;
  }

  createMeet() {
    this.options.userInfo.displayName = this.currentUser.fullName;
    this.options.parentNode = document.querySelector('#jitsi');
    this.options.roomName = `smartboard_${this.sessionPin}`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.api = new (window as any).JitsiMeetExternalAPI(this.domain, this.options);
    this.api.on('readyToClose', () => {
      this.currentUser.type === 'User' ? this.stopMeet() : this.leaveMeet();
    });
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.applyMinMax);
    this.disposeJitsi();
  }

  disposeJitsi() {
    if (this.api) this.api.dispose();
  }

  manipulating = false;

  handleDragStart({ set, inputEvent }: OnDragStart) {
    const e = inputEvent as MouseEvent;
    const button = document.getElementById('joinMeet');
    if (button?.contains(e.target as HTMLElement)) return;
    this.applyTransform();
    set([this.rect.x, this.rect.y]);
    this.applyTransform();
    this.manipulating = true;
  }

  handleDrag({ beforeTranslate }: OnDrag) {
    this.rect.x = beforeTranslate[0];
    this.rect.y = beforeTranslate[1];
    this.applyMinMax();
  }

  handleDragEnd() {
    this.manipulating = false;
  }

  applyMinMax() {
    const interfaceEl = document.querySelector('.interface');
    const interfaceWidth = interfaceEl?.getBoundingClientRect().width || 0;

    this.rect.height = Math.min(this.rect.height, window.innerHeight * 0.98);
    this.rect.width = Math.min(this.rect.width, interfaceWidth * 0.98);
    this.rect.x = Math.max(Math.min(this.rect.x, -this.rect.width + 20), -interfaceWidth + 40);
    const height = this.minimised ? 36 : this.rect.height;
    const offset = this.isGuest ? 25 : 90;
    this.rect.y = Math.min(Math.max(this.rect.y, height / 2 - offset), window.innerHeight - 10 - height / 2 - offset);
    this.applyTransform();
    this.$nextTick(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs.moveable as any).updateRect();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs.moveable as any).updateTarget();
    });
  }

  handleResizeStart() {
    this.manipulating = true;
  }

  handleResize(data: OnResize) {
    const { width, height } = { ...data };
    const offset = [data.direction[0] < 0 ? -data.delta[0] : 0, data.direction[1] < 0 ? -data.delta[1] : 0];
    this.rect.x = offset[0] + data.drag.beforeTranslate[0];
    this.rect.y = offset[1] + data.drag.beforeTranslate[1];
    this.rect.width = width;
    this.rect.height = height;
    this.applyMinMax();
  }

  handleResizeEnd() {
    this.manipulating = false;
  }

  applyTransform() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const target = (this.$refs.moveable as any).$el;
    target.style.transform = `translate3d(${this.rect.x}px, ${this.rect.y}px, 0)`;
    target.style.width = `${this.rect.width}px`;
    target.style.height = `${this.rect.height}px`;
  }
}
